export default __webpack_public_path__ + "static/media/Guvrix-Logo.a5d9a23a.png";